import { Select, TextInput } from '@mantine/core'

import { useQueryGetUserLogged } from '@flecto/core/shared'
import { useTranslation } from '@flecto/translations'

import { useOnboardingNavigation } from '../../hooks/useOnboardingNavigation'
import { useOnboardingSelectOptions } from '../../hooks/useOnboardingSelectOptions'
import { useFormContext } from './FormOnboarding'
import { StepWrapper } from './StepWrapper'

export function Step01() {
  const { t } = useTranslation('saas', { keyPrefix: 'onboarding' })
  const { data: user } = useQueryGetUserLogged()
  const { nextStep } = useOnboardingNavigation()
  const { qtyEmployees } = useOnboardingSelectOptions()

  const form = useFormContext()

  const handleNext = () => {
    form.validate()

    const isValid =
      form.isValid('step_basic_info.first_name') &&
      form.isValid('step_basic_info.last_name') &&
      form.isValid('step_basic_info.company_name') &&
      form.isValid('step_basic_info.qty_employees')

    if (!isValid) {
      return
    }

    form.clearErrors()
    nextStep()
  }

  return (
    <StepWrapper
      stepNumber={1}
      title={t('steps.basic_info.title')}
      description={t('steps.basic_info.description', {
        replace: { email: user?.email },
      })}
      onNextStep={handleNext}
    >
      <TextInput
        {...form.getInputProps('step_basic_info.first_name')}
        label={t('form_labels.first_name')}
        withAsterisk
        mb='md'
      />
      <TextInput
        {...form.getInputProps('step_basic_info.last_name')}
        label={t('form_labels.last_name')}
        withAsterisk
        mb='md'
      />
      <TextInput
        {...form.getInputProps('step_basic_info.company_name')}
        label={t('form_labels.company_name')}
        withAsterisk
        mb='md'
      />
      <Select
        {...form.getInputProps('step_basic_info.qty_employees')}
        label={t('form_labels.qty_employees')}
        placeholder={t('form_placeholders.pick_one')}
        data={qtyEmployees}
        withAsterisk
        mb='md'
      />
    </StepWrapper>
  )
}
